import axios from "axios";
import { GET_EVENT_STATUSES } from "./types";
import { endpoint } from "../config";

export const getEventStatuses = (limit = 100) => (dispatch, getState) => {
  let params = "?limit=" + limit;
  const token = getState().auth.token;
  const config = {
    headers: {
      "Content-Type": "application/json"
    }
  };
  if (token) {
    config.headers["Authorization"] = `Token ${token}`;
  }
  axios
    .get(endpoint + "/events/status/" + params, config)
    .then(res => {
      dispatch({
        type: GET_EVENT_STATUSES,
        payload: res.data
      });
    })
    .catch(err => console.log(err));
};
